import axios from 'axios';
import store from '../store';
import { getTokens } from '../api/login'
import {  setToken } from '@/utils/auth';

var mixin = {
	methods: {
    req401(err,fn){
      if((err+'').indexOf('401') > -1){
        getTokens().then(res=>{
          setToken(res.token);
          store.commit('SET_ADMIN_TOKEN', res.token);
          fn&&fn();
        })
      }
    }
  },
}
export default mixin;



// WEBPACK FOOTER //
// ./src/mixin/index.js